import React from 'react'

interface BlankPageLayoutProps {
  /** Omit when the surface already names itself — a tab label, a dialog's own title. */
  title?: React.ReactNode // Normally Just a string
  subtitle?: React.ReactNode // Normally Just a string
  className?: string
  children: React.ReactNode
  stretch?: boolean
}
export const BlankPageLayout = (props: BlankPageLayoutProps) => (
  <div className={`w-full flex flex-col mx-auto p-4 space-y-4 ${props.className ?? ''}`}>
    {(props.title || props.subtitle) && (
      <div className="w-full space-y-1">
        {/* One step under the page bar's own title, which is on screen directly above this. */}
        {props.title && (
          <h1 className="text-lg font-semibold text-mm-neutral-1-900">{props.title}</h1>
        )}
        {props.subtitle && (
          <p className="max-w-2xl text-sm text-mm-neutral-1-600">{props.subtitle}</p>
        )}
      </div>
    )}
    {/* No `items-center`: it let a block child shrink to its content's width, which
        collapsed full-width rows and broke fixed-width grids nested here. */}
    <div className={`mx-auto w-full flex flex-col ${props.stretch ? '' : 'max-w-7xl'}`}>
      {props.children}
    </div>
  </div>
)
